(() => {
  const phone = window.matchMedia('(max-width: 760px)');
  const menuInertStates = new Map();
  const syncScrollLock = () => document.body.classList.toggle('cl-overlay-open', !!document.querySelector('#ClCartDrawer[open], .cl-header[data-menu-open="true"]'));
  const restoreMenuInert = () => {
    menuInertStates.forEach((previous, element) => { element.inert = previous; });
    menuInertStates.clear();
  };
  const makeMenuModal = (header) => {
    document.body.querySelectorAll(':scope > *').forEach(element => {
      if (element.contains(header) || element === header || element.matches('script, style, dialog')) return;
      menuInertStates.set(element, element.inert);
      element.inert = true;
    });
    header.querySelectorAll('.cl-brand, .cl-menu-toggle, .cl-header__actions').forEach(element => {
      menuInertStates.set(element, element.inert);
      element.inert = true;
    });
    const menu = header.querySelector('.cl-nav');
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    header.querySelector('.cl-menu-close')?.focus({preventScroll: true});
  };
  const loadBestsellers = async (header) => {
    const block = header.querySelector('[data-bestsellers-url]');
    if (!phone.matches || !block || block.dataset.bestsellersMode === 'manual' || block.dataset.loaded === 'true' || block.dataset.loading === 'true') return;
    block.dataset.loading = 'true';
    const url = new URL(block.dataset.bestsellersUrl, window.location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('sections', block.dataset.sectionId);
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    try {
      const response = await fetch(url, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Section unavailable');
      const sections = await response.json();
      const html = sections[block.dataset.sectionId];
      if (!html) throw new Error('Section unavailable');
      const products = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bestseller-products]');
      if (!products || products.querySelector('[role="status"]')) throw new Error('Collection unavailable');
      block.querySelector('[data-bestseller-products]').replaceChildren(...products.childNodes);
      block.dataset.loaded = 'true';
    } catch (_) {
      block.querySelector('[data-bestseller-products]').replaceChildren(block.querySelector('[data-bestseller-error]').content.cloneNode(true));
    } finally { delete block.dataset.loading; }
  };
  const closeCollectionMenus = (root = document) => {
    root.querySelectorAll('.cl-collection-menu[open]').forEach((dropdown) => {
      dropdown.open = false;
    });
  };

  const closeMobileMenu = (header) => {
    const menuButton = header.querySelector('.cl-menu-toggle');
    menuButton?.setAttribute('aria-expanded', 'false');
    header.dataset.menuOpen = 'false';
    closeCollectionMenus(header);
    header.querySelector('.cl-nav')?.removeAttribute('role');
    header.querySelector('.cl-nav')?.removeAttribute('aria-modal');
    restoreMenuInert();
    syncScrollLock();
  };

  const initializeHeaderMenus = (root = document) => {
    const headers = root.matches?.('.cl-header') ? [root] : root.querySelectorAll('.cl-header');
    headers.forEach((header) => {
      if (header.dataset.menuInitialized === 'true') return;
      const menuButton = header.querySelector('.cl-menu-toggle');
      const menu = header.querySelector('.cl-nav');
      if (!menuButton || !menu) return;
      header.dataset.menuInitialized = 'true';

      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') !== 'true';
        if (!open) { closeMobileMenu(header); return; }
        menuButton.setAttribute('aria-expanded', String(open));
        header.dataset.menuOpen = String(open);
        if (phone.matches) { makeMenuModal(header); loadBestsellers(header); syncScrollLock(); }
      });
      header.querySelectorAll('.cl-menu-close, .cl-menu-backdrop').forEach(button => {
        button.addEventListener('click', () => { closeMobileMenu(header); menuButton.focus({preventScroll: true}); });
      });
      menu.addEventListener('click', (event) => {
        if (event.target.closest('[data-bestseller-retry]')) { loadBestsellers(header); return; }
        if (!event.target.closest('a')) return;
        closeMobileMenu(header);
      });
      loadBestsellers(header);
      header.querySelectorAll('.cl-collection-menu').forEach((dropdown) => {
        dropdown.addEventListener('toggle', () => {
          if (!dropdown.open) return;
          header.querySelectorAll('.cl-collection-menu[open]').forEach((other) => {
            if (other !== dropdown) other.open = false;
          });
          const panel = dropdown.querySelector('.cl-collection-menu__panel');
          if (panel) panel.scrollTop = 0;
        });
      });
    });
  };

  initializeHeaderMenus();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.cl-header')) { restoreMenuInert(); syncScrollLock(); }
    initializeHeaderMenus(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.querySelector('.cl-header[data-menu-open="true"]');
    if (header) closeMobileMenu(header);
  });
  document.addEventListener('cl:close-menu', () => {
    document.querySelectorAll('.cl-header[data-menu-open="true"]').forEach(closeMobileMenu);
  });
  const resetMenus = () => {
    document.querySelectorAll('.cl-header[data-menu-open="true"]').forEach(closeMobileMenu);
    document.querySelectorAll('.cl-header').forEach(loadBestsellers);
  };
  phone.addEventListener('change', resetMenus);
  window.matchMedia('(max-width: 1000px)').addEventListener('change', resetMenus);
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.cl-collection-menu[open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
    document.querySelectorAll('.cl-header[data-menu-open="true"]').forEach((header) => {
      if (!header.contains(event.target)) closeMobileMenu(header);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && phone.matches) {
      const menu = document.querySelector('.cl-header[data-menu-open="true"] .cl-nav');
      if (!menu) return;
      const controls = [...menu.querySelectorAll('a[href], button:not([disabled]), summary, input, select, [tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      return;
    }
    if (event.key !== 'Escape') return;
    const dropdown = document.querySelector('.cl-collection-menu[open]');
    if (dropdown) {
      event.preventDefault();
      dropdown.open = false;
      dropdown.querySelector('summary')?.focus();
      return;
    }
    const header = document.querySelector('.cl-header[data-menu-open="true"]');
    if (header) {
      event.preventDefault();
      closeMobileMenu(header);
      header.querySelector('.cl-menu-toggle')?.focus();
    }
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-variant-selector]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      const productPage = form?.closest('.cl-product-page');
      const price = productPage?.querySelector('[data-product-price]');
      const button = form?.querySelector('[name="add"]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (productPage && option?.dataset.packageScale) productPage.style.setProperty('--cl-package-scale', option.dataset.packageScale);
      if (button && option) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      }
    });
  });

  document.querySelectorAll('[data-product-image]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = button.closest('.cl-product-page__gallery')?.querySelector('.cl-product-page__main-image');
      if (!image) return;
      image.classList.remove('cl-packshot-ready');
      image.removeAttribute('srcset');
      image.src = button.dataset.productImage;
      button.closest('.cl-product-page__gallery').querySelectorAll('.cl-thumb').forEach((thumb) => {
        thumb.removeAttribute('aria-current');
        thumb.classList.remove('is-active');
      });
      button.setAttribute('aria-current', 'true');
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-copy-link]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      if (!navigator.clipboard?.writeText) return;
      event.preventDefault();
      try {
        await navigator.clipboard.writeText(link.href);
        link.textContent = link.dataset.copiedLabel || 'Enlace copiado';
      } catch (_) {
        window.location.assign(link.href);
      }
    });
  });
})();
